import { Box, Container, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import workDiary from '../../assets/images/word_diary.png';
import surveyDiary from '../../assets/images/survey_dairy.png';
const ClientAdminDiary = () => {
  const navigate = useNavigate();
  const handleBoxClick = () => {
    navigate('/survey-diary'); // Replace with your target route
  };

  const handleWorkBoxClick = () => {
    navigate('/work-diary'); // Replace with your target route
  };
  const {leadDetails} = useSelector((state:any) => state.lead);
  useEffect(()=>{
    console.log("leadDetails",leadDetails);
  },[leadDetails])
  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ background: "#f4f4f4", paddingTop: "0px", height: "90vh", alignContent: "center", }}
      >
        <Grid item xs={12} md={6}>
          <Container
            maxWidth="md"
            sx={{
              bgcolor: "#fff",
              padding: "16px !important",
              borderRadius: "10px",
            }}
          >
            <Box onClick={handleWorkBoxClick}
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto", sm: "50vh" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                padding: "4px 12px",
                textAlign: "center",
                alignItems: "center",
                alignContent: "center",cursor:'pointer'
              }}
            >
              <img src={workDiary} alt="Work"/>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {" "}
                Work Diary
              </Typography>
              <Typography variant="h6">
                {" "}
                This is where you can allocate workers and vehicles
              </Typography>
            </Box>
          </Container>
        </Grid>
        <Grid item xs={12} md={6}>
          <Container
            maxWidth="md"
            sx={{
              bgcolor: "#fff",
              padding: "16px !important",
              borderRadius: "10px",
            }}
          >
            <Box onClick={handleBoxClick}
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto", sm: "50vh" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                padding: "4px 12px",
                textAlign: "center",
                alignItems: "center",
                alignContent: "center", cursor:'pointer'
              }}
            >
              <img src={surveyDiary} alt="Survey"/>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {" "}
                Survey Diary
              </Typography>
              <Typography variant="h6">
                {" "}
                This is where you can schedule a survey
              </Typography>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};
export default ClientAdminDiary;
